module.exports = __webpack_public_path__ + "static/lucaswork3-8abe8ff8da65e54dc8197f957d30862a.jpg";